import { HStack, Select, Text } from "@chakra-ui/react";
import React from "react";
import { MdArrowDropDown } from "react-icons/md";
import { useSelector } from "react-redux";
 
export const ApprovedEmailLists = ({ emailList, updateSelectedEmail }) => {
  const loginUserEmail =
    useSelector((state) => state.userEmail) || localStorage.getItem("userEmail");
 
  const handleEmailChange = (e) => {
    updateSelectedEmail(e.target.value);
  };
 
  // Check if loginUserEmail is already in the list
  const isLoginEmailInList = emailList?.some(email => email.email_id === loginUserEmail);
 
  return (
    <HStack gap={1} position="relative">
      <Text
        as={"samp"}
        position="absolute"
        top="-3"
        left="3"
        zIndex="1"
        background="#ffffff"
        px="1"
        color={"blue"}
      >
        Approved emails
      </Text>
      <Select
        w={"300px"}
        onChange={handleEmailChange}
        icon={<MdArrowDropDown />}
        placeholder="select an email"
      >
        {/* Show login email first if not already in the list */}
        {!isLoginEmailInList && loginUserEmail && (
          <option value={loginUserEmail}>{loginUserEmail}</option>
        )}
        {emailList?.map((email, index) => (
          <React.Fragment key={index}>
            <option value={email.email_id}>
              {email.email_id} ({email.total_active_campaign})
            </option>
            {email.alias_emails && email.alias_emails.map((alias, aIdx) => (
              <option key={aIdx} value={alias.email}>
              {alias.email} ({alias.total_active_campaign})
              </option>
            ))}
          </React.Fragment>
        ))}
      </Select>
    </HStack>
  );
};